// ============================================================================
// Login.js — tela de login (visual Samsung).
// ============================================================================
import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const SAMSUNG = "'Samsung Sharp Sans', 'SamsungOne', 'SamsungOne UI', sans-serif";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const u = await login(username.trim(), password);
      // loja → Sales Day 2.0; superadmin → seletor
      window.location.assign(u.role === 'loja' ? '/sales-day-2' : '/');
    } catch (err) {
      setErro(err.response?.data?.detail || 'Não foi possível entrar. Verifique usuário e senha.');
      setLoading(false);
    }
  };

  const input = {
    width: '100%', padding: '13px 15px', borderRadius: 12, border: '1px solid #d9dde3',
    background: '#fff', fontSize: 16, fontFamily: SAMSUNG, color: '#0f172a', outline: 'none',
    boxSizing: 'border-box',
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #F8F9FB 0%, #eef1f7 100%)', fontFamily: SAMSUNG, padding: 20,
    }}>
      <form onSubmit={submit} style={{
        width: '100%', maxWidth: 380, background: '#fff', borderRadius: 22, padding: '38px 34px',
        border: '1px solid #e8edf3', boxShadow: '0 18px 50px rgba(20,40,160,0.10)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 26 }}>
          <h1 style={{ fontSize: 30, fontWeight: 700, color: '#1428A0', letterSpacing: '-0.03em', margin: 0 }}>Up&amp;Help</h1>
          <p style={{ fontSize: 14, fontWeight: 400, color: '#1428A0', opacity: 0.6, margin: '6px 0 0' }}>
            Controle Operacional · Samsung
          </p>
        </div>

        <label style={{ fontSize: 12.5, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Usuário</label>
        <input
          style={{ ...input, marginTop: 6, marginBottom: 16 }}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus autoComplete="username" placeholder="seu login"
        />

        <label style={{ fontSize: 12.5, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Senha</label>
        <input
          style={{ ...input, marginTop: 6 }}
          type="password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password" placeholder="••••••"
        />

        {erro && (
          <div style={{
            marginTop: 16, padding: '10px 13px', borderRadius: 10, background: 'rgba(255,67,55,0.08)',
            border: '1px solid rgba(255,67,55,0.22)', color: '#D63A2F', fontSize: 13.5, fontWeight: 600,
          }}>{erro}</div>
        )}

        <button type="submit" disabled={loading || !username || !password} style={{
          width: '100%', marginTop: 22, padding: '13px', borderRadius: 12, border: 'none',
          background: (loading || !username || !password) ? '#9fb0d8' : '#1428A0', color: '#fff',
          fontSize: 16, fontWeight: 700, fontFamily: SAMSUNG, cursor: (loading || !username || !password) ? 'default' : 'pointer',
          transition: 'background 0.15s, transform 0.1s',
        }}>
          {loading ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
